import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-toastify/dist/ReactToastify.css";
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";

// Importez tous vos composants de pages
import Home from "./pages/Home";
import Checkout from "./pages/checkout";
import Produits from "./pages/produits";
import ProduitsDetails from "./pages/produitsDetails";
import NaveBar from "./pages/naveBar";
import Footer from "./pages/footer";
import { CartProvider } from "./pages/CartContext";
import AchatExternalise from "./pages/AchatExternalise";
function App() {
  return (
    <CartProvider>
      <Router>
        <div>
          <NaveBar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/produits" element={<Produits />} />
            <Route path="/checkout" element={<Checkout />} />
            <Route
              path="/produitsDetails/:id_prod"
              element={<ProduitsDetails />}
            />
            <Route path="/achat-externalise" element={<AchatExternalise />} />
          </Routes>
          <Footer />

          {/* Intégration de React-Toastify pour les notifications */}
          <ToastContainer
            position="bottom-right"
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
          />
        </div>
      </Router>
    </CartProvider>
  );
}
export default App;
